export default function getInputValidationClasses(name, control, index = null) {
  // FIXME - Do we have a better solution for this?
  // Control
  // This object contains methods for registering components into React Hook Form.
  // Important: do not access any of the properties inside this object directly. It's for internal usage only.
  // =) =P

  const formState = control._formState

  const { errors, touchedFields } = formState

  if (errors[name] === undefined && touchedFields[name]) {
    return "border-green-100"
  }

  if (errors[name] || (errors[name] && errors[name][index])) {
    return "border-red-100 has-error"
  }

  //   if (touchedFields[name] && !control.fieldsWithValidationRef[name] && !index) {
  //     return "border-green-100"
  //   }

  //   if (
  //     touchedFields[name] &&
  //     touchedFields[name][index] &&
  //     !control.fieldsWithValidationRef[name] &&
  //     control.fieldsWithValidationRef[name] &&
  //     !control.fieldsWithValidationRef[name][index]
  //   ) {
  //     return "border-green-100"
  //   }

  return ""
}
